import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getFontSize, getSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Popover } from "./auth-service-tools264.js";
import { ComboboxProvider } from "./auth-service-tools332.js";
import { ComboboxChevron } from "./auth-service-tools329.js";
import { ComboboxClearButton } from "./auth-service-tools333.js";
import { ComboboxDropdown } from "./auth-service-tools334.js";
import { ComboboxDropdownTarget } from "./auth-service-tools335.js";
import { ComboboxEmpty } from "./auth-service-tools336.js";
import { ComboboxEventsTarget } from "./auth-service-tools337.js";
import { ComboboxFooter } from "./auth-service-tools338.js";
import { ComboboxGroup } from "./auth-service-tools339.js";
import { ComboboxHeader } from "./auth-service-tools340.js";
import { ComboboxHiddenInput } from "./auth-service-tools341.js";
import { ComboboxOption } from "./auth-service-tools342.js";
import { ComboboxOptions } from "./auth-service-tools343.js";
import { ComboboxSearch } from "./auth-service-tools344.js";
import { ComboboxTarget } from "./auth-service-tools345.js";
import { useCombobox } from "./auth-service-tools346.js";
import classes from "./auth-service-tools330.js";
const defaultProps = {
  keepMounted: true,
  withinPortal: true,
  resetSelectionOnOptionHover: false,
  width: "target",
  transitionProps: {
    transition: "fade",
    duration: 0
  }
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size,
    dropdownPadding
  } = _ref;
  return {
    options: {
      "--combobox-option-fz": getFontSize(size),
      "--combobox-option-padding": getSize(size, "combobox-option-padding")
    },
    dropdown: {
      "--combobox-padding": dropdownPadding === void 0 ? void 0 : rem(dropdownPadding),
      "--combobox-option-fz": getFontSize(size),
      "--combobox-option-padding": getSize(size, "combobox-option-padding")
    }
  };
});

function Combobox(_props) {
  const props = useProps("Combobox", defaultProps, _props);
  const {
    classNames,
    styles,
    unstyled,
    children,
    store: controlledStore,
    vars,
    onOptionSubmit,
    onClose,
    size,
    dropdownPadding,
    resetSelectionOnOptionHover,
    __staticSelector,
    readOnly,
    ...others
  } = props;
  const uncontrolledStore = useCombobox();
  const store = controlledStore || uncontrolledStore;
  const getStyles = useStyles({
    name: __staticSelector || "Combobox",
    classes,
    props,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });

  const onDropdownClose = () => {
    onClose == null ? void 0 : onClose();
    store.closeDropdown();
  };

  return /* @__PURE__ */jsxRuntimeExports.jsx(ComboboxProvider, {
    value: {
      getStyles,
      store,
      onOptionSubmit,
      size,
      resetSelectionOnOptionHover,
      readOnly
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Popover, {
      opened: store.dropdownOpened,
      ...others,
      onChange: _opened => !_opened && onDropdownClose(),
      withRoles: false,
      unstyled,
      children
    })
  });
}

const extendCombobox = c => c;

Combobox.extend = extendCombobox;
Combobox.classes = classes;
Combobox.displayName = "@mantine/core/Combobox";
Combobox.Target = ComboboxTarget;
Combobox.Dropdown = ComboboxDropdown;
Combobox.Options = ComboboxOptions;
Combobox.Option = ComboboxOption;
Combobox.Search = ComboboxSearch;
Combobox.Empty = ComboboxEmpty;
Combobox.Chevron = ComboboxChevron;
Combobox.Footer = ComboboxFooter;
Combobox.Header = ComboboxHeader;
Combobox.EventsTarget = ComboboxEventsTarget;
Combobox.DropdownTarget = ComboboxDropdownTarget;
Combobox.Group = ComboboxGroup;
Combobox.ClearButton = ComboboxClearButton;
Combobox.HiddenInput = ComboboxHiddenInput;
export { Combobox };